import { render } from "./add_student.vue?vue&type=template&id=328c8d76"
import script from "./add_student.vue?vue&type=script&lang=js"
export * from "./add_student.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__